module.exports = __webpack_public_path__ + "static/media/englishPage2.60944abc.jpg";